// src/packages/dhipaya/motor/dhipaya_car_shortterm_180d/index.js
import DhipayaShort180Card from "./DhipayaShort180Card";
import DhipayaShort180Details from "./DhipayaShort180Details";
import "./dhipaya_short180.css";

/** Dhipaya — 2+ / 3+ ระยะสั้น 180 วัน (Effective 21.04.2025) */
export default {
  id: "dhipaya_car_shortterm_180d_2025",
  company: "ทิพยประกันภัย (Dhipaya)",     // ให้ตรงกับ COMPANY_INFO
  productLine: "motor",
  categories: ["private car", "2+", "3+", "short-term"],
  nameTH: "รถยนต์ 2+ / 3+ ระยะสั้น 180 วัน",
  description: "คุ้มครอง 180 วัน — 2+ / 3+ สำหรับรถใช้งานส่วนบุคคล (ตามเงื่อนไขบริษัท)",
  accent: "#004aad",
  expiresAt: "9999-12-31",
  card: DhipayaShort180Card,
  detail: DhipayaShort180Details,
  active: true
};
